import { useParams } from "react-router-dom";
import { ParamsNames } from "../constantes/paramsNames";

/**
 * Hook pour obtenir le locale depuis l'URL
 * Retourne 'en-US' par défaut si non présent
 */
export const useLocale = (): string => {
  const params = useParams<{ [key: string]: string }>();
  const localeFromUrl = params[ParamsNames.LOCALE];
  
  return localeFromUrl || "en-US";
};

